module.exports = {"Type":"AdaptiveCardShow","Disabled":false,"Output":true,"Fields":[{"label":"Card Definition","name":"text","type":"multiline","serializeTo":"q"},{"label":"Update last activity","type":"yesno","defaultValue":"No","name":"updateLastActivity","advanced":true}],"Header":{"Color":"white","BackgroundColor":"#EE1010","Text":"CARD"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/AdaptiveCardShow.json
// module id = 679
// module chunks = 0